/* Martin's Collectables: Cover Story Lab behaviour (v0.3.0). No dependencies. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(pointer: fine)').matches;

  /* Just-scanned ticker */
  function initTicker(root) {
    const items = [...root.querySelectorAll('.mc-ticker__item')];
    if (items.length < 2) return;
    let i = 0;
    let timer = null;
    const count = root.querySelector('[data-mc-ticker-count]');
    const show = (n) => {
      items[i].classList.remove('is-active');
      i = (n + items.length) % items.length;
      items[i].classList.add('is-active');
      if (count) count.textContent = `${i + 1} / ${items.length}`;
    };
    const start = () => {
      if (reduceMotion) return;
      stop();
      timer = setInterval(() => show(i + 1), 3800);
    };
    const stop = () => timer && clearInterval(timer);
    root.querySelector('[data-mc-ticker-next]')?.addEventListener('click', () => { show(i + 1); start(); });
    root.querySelector('[data-mc-ticker-prev]')?.addEventListener('click', () => { show(i - 1); start(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    /* Swipe left or right on phones; a tap still opens the item */
    const list = root.querySelector('.mc-ticker__list');
    let x0 = null, y0 = null;
    list?.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; stop(); }, { passive: true });
    list?.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      const dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(dx < 0 ? i + 1 : i - 1);
      start();
    }, { passive: true });
    start();
  }

  /* Flip (cover story and light table) */
  function bindFlip(scope) {
    scope.querySelectorAll('[data-mc-flip]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const host = btn.closest('.mc-cover__stage, .mc-lt');
        const flipper = host?.querySelector('[data-mc-flipper]');
        if (!flipper) return;
        flipper.style.transform = '';
        const back = flipper.classList.toggle('is-back');
        btn.setAttribute('aria-pressed', String(back));
      });
    });
  }

  /* Gentle tilt on the hero slab */
  function initTilt(stage) {
    const slab = stage.querySelector('.mc-slab');
    if (!slab || reduceMotion || !finePointer) return;
    stage.addEventListener('pointermove', (e) => {
      const r = slab.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      const flip = slab.classList.contains('is-back') ? 180 : 0;
      slab.style.transform = `rotateY(${flip + x * 10}deg) rotateX(${-y * 8}deg)`;
    });
    stage.addEventListener('pointerleave', () => { slab.style.transform = ''; });
  }

  /* Inspect points: label, signature, cert */
  /* Drag a close-up window to look around the photo. x and y run 0..1 (0 0 = top left). */
  function initPan(win) {
    const img = win.querySelector('img');
    if (!img || win.dataset.mcPan) return;
    win.dataset.mcPan = '1';
    let x = parseFloat(win.dataset.x || '0.5');
    let y = parseFloat(win.dataset.y || '0');
    const room = () => [Math.max(0, img.offsetWidth - win.clientWidth), Math.max(0, img.offsetHeight - win.clientHeight)];
    const place = () => {
      const [rx, ry] = room();
      img.style.transform = `translate(${-rx * x}px, ${-ry * y}px)`;
    };
    let start = null;
    win.addEventListener('pointerdown', (e) => { start = { px: e.clientX, py: e.clientY, x, y }; win.setPointerCapture(e.pointerId); });
    win.addEventListener('pointermove', (e) => {
      if (!start) return;
      const [rx, ry] = room();
      x = rx ? Math.min(1, Math.max(0, start.x - (e.clientX - start.px) / rx)) : x;
      y = ry ? Math.min(1, Math.max(0, start.y - (e.clientY - start.py) / ry)) : y;
      place();
    });
    const end = () => { start = null; };
    win.addEventListener('pointerup', end);
    win.addEventListener('pointercancel', end);
    if (img.complete) place(); else img.addEventListener('load', place, { once: true });
    window.addEventListener('resize', place);
    win.mcPlace = place;
  }

  function initInspect(box) {
    const view = box.querySelector('[data-mc-zoom-view]');
    const buttons = [...box.querySelectorAll('[data-mc-zoom]')];
    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const on = btn.getAttribute('aria-pressed') !== 'true';
        buttons.forEach((b) => b.setAttribute('aria-pressed', 'false'));
        if (on) {
          btn.setAttribute('aria-pressed', 'true');
          view.dataset.view = btn.dataset.mcZoom;
          view.hidden = false;
          const win = view.querySelector(`.mc-zoom__win--${btn.dataset.mcZoom}`);
          if (win) { initPan(win); win.mcPlace?.(); }
        } else {
          view.hidden = true;
        }
      });
    });
  }

  /* Add to bag without leaving the page; refresh Dawn's bag bubble */
  function bindAdd(scope) {
    if (scope.dataset && scope.dataset.mcAddBound) return;
    if (scope.dataset) scope.dataset.mcAddBound = '1';
    scope.addEventListener('submit', async (e) => {
      const form = e.target.closest('[data-mc-add]');
      if (!form || e.defaultPrevented) return;
      {
        e.preventDefault();
        const btn = form.querySelector('button');
        const label = btn.textContent;
        btn.disabled = true;
        try {
          const body = new FormData(form);
          body.append('sections', 'cart-icon-bubble');
          const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body,
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || 'Could not add');
          const bubble = document.getElementById('cart-icon-bubble');
          const html = data.sections?.['cart-icon-bubble'];
          if (bubble && html) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fresh = doc.querySelector('.shopify-section');
            if (fresh) bubble.innerHTML = fresh.innerHTML;
          }
          btn.textContent = 'In your bag';
        } catch (err) {
          btn.textContent = err.message.includes('sold') ? 'Just sold' : 'Try again';
          btn.disabled = false;
          setTimeout(() => { btn.textContent = label; }, 2600);
        }
      }
    });
  }

  /* Collection pages: one button per grade. On a paged list a grade opens "View all"
     at that grade, so the filter covers every item, not just this page. */
  function buildGrades(rack, cards) {
    const bar = rack.querySelector('[data-mc-grades]');
    if (!bar) return;
    const allUrl = bar.dataset.allUrl;
    /* No graded items on the page (raw comics): no grade buttons; show publishers instead */
    if (!cards.some((c) => c.dataset.grade)) {
      const pubs = rack.querySelector('[data-mc-pubs]');
      if (pubs) pubs.hidden = false;
      return;
    }
    /* One-page list: the grades on the cards. Paged list: the usual grades for this kind of item
       (CGC comics or graded cards) plus any grade on this page, since the rest aren't loaded. */
    const here = cards.map((c) => c.dataset.grade).filter(Boolean);
    const graded = cards.filter((c) => c.dataset.grade);
    const mostlyCards = graded.filter((c) => c.dataset.label === 'card').length > graded.length / 2;
    const usual = mostlyCards ? ['10', '9.5', '9', '8.5', '8'] : ['10', '9.9', '9.8', '9.6', '9.4', '9.2', '9.0'];
    /* "9" and "9.0" are one grade: one button, spelled the way this page's cards spell it */
    const spelled = new Map();
    here.forEach((g) => { if (!spelled.has(Number(g))) spelled.set(Number(g), g); });
    if (allUrl) usual.forEach((g) => { if (!spelled.has(Number(g))) spelled.set(Number(g), g); });
    const grades = [...spelled.values()].sort((a, b) => b - a);
    if (!grades.length) return;
    ['all', ...grades].forEach((g) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mc-filter mc-mono';
      btn.dataset.mcFilter = g;
      btn.textContent = g === 'all' ? 'All' : g;
      btn.setAttribute('aria-pressed', String(g === 'all'));
      if (allUrl && g !== 'all') {
        btn.dataset.href = `${allUrl}#grade=${g}`;
        btn.addEventListener('click', (e) => { e.stopImmediatePropagation(); location.href = btn.dataset.href; });
      }
      bar.appendChild(btn);
    });
    bar.hidden = false;
  }

  async function loadMore(grid) {
    let next = grid.dataset.mcMore;
    delete grid.dataset.mcMore;
    /* Each page is fetched once, and a book already on the rack (same stack key) is not added twice */
    const visited = new Set([location.pathname + location.search]);
    const seen = new Set([...grid.querySelectorAll('[data-mc-card]')].map((c) => c.dataset.stack || c.querySelector('a')?.getAttribute('href')));
    while (next && !visited.has(next) && visited.size < 40) {
      visited.add(next);
      try {
        const res = await fetch(next);
        if (!res.ok) break;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const more = doc.querySelector('.mc-rack__grid');
        let added = 0;
        more?.querySelectorAll('[data-mc-card]').forEach((c) => {
          const key = c.dataset.stack || c.querySelector('a')?.getAttribute('href');
          if (seen.has(key)) return;
          seen.add(key);
          c.dataset.index = grid.children.length + 1;
          grid.appendChild(c);
          added += 1;
        });
        if (!added) break;
        next = more?.dataset.mcMore;
      } catch (err) { break; }
    }
    grid.closest('.collection')?.querySelector('.pagination-wrapper')?.setAttribute('hidden', '');
  }

  /* The rack: filters, sort, light table */
  function initRack(rack) {
    if (rack.dataset.mcRackBound) return;
    rack.dataset.mcRackBound = '1';
    const grid = rack.querySelector('.mc-rack__grid');
    if (!grid) return;
    /* One-page view of a list over 250: fetch the rest before filtering */
    if (grid.dataset.mcMore) {
      loadMore(grid).then(() => { delete rack.dataset.mcRackBound; initRack(rack); });
      return;
    }
    /* Homepage: a fresh random mix from the pool on every visit */
    const keep = Number(rack.dataset.mcShuffle);
    if (keep) {
      const pool = [...grid.querySelectorAll('[data-mc-card]')];
      for (let i = pool.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [pool[i], pool[j]] = [pool[j], pool[i]];
      }
      pool.forEach((c, i) => { if (i < keep) { c.dataset.index = i + 1; grid.appendChild(c); } else c.remove(); });
    }
    const cards = [...grid.querySelectorAll('[data-mc-card]')];
    buildGrades(rack, cards);
    const empty = rack.querySelector('[data-mc-empty]');
    const filters = [...rack.querySelectorAll('[data-mc-filter]')];
    const sort = rack.querySelector('[data-mc-sort]');

    const matches = (card, f) => {
      if (f === 'all') return true;
      if (f === 'signed') return card.dataset.signed === 'true';
      if (f === 'card') return card.dataset.label === 'card';
      if (f.startsWith('pub:')) return card.dataset.pub === f.slice(4);
      return card.dataset.grade !== '' && Number(card.dataset.grade) === Number(f);
    };
    /* One-page view: optional paging in the browser, so the picked grade stays picked */
    const pagingBtn = rack.querySelector('[data-mc-paging]');
    const pager = rack.querySelector('[data-mc-pager]');
    const per = Number(pagingBtn?.dataset.per) || 20;
    let paging = false;
    let page = 0;
    let current = 'all';
    const apply = (f = current) => {
      current = f;
      const hits = [...grid.querySelectorAll('[data-mc-card]')].filter((c) => matches(c, f));
      const pages = Math.max(1, Math.ceil(hits.length / per));
      page = Math.min(page, pages - 1);
      cards.forEach((c) => { c.hidden = true; });
      hits.forEach((c, i) => { c.hidden = paging && (i < page * per || i >= (page + 1) * per); });
      if (empty) empty.hidden = hits.length > 0;
      if (pager) {
        pager.hidden = !paging || pages < 2;
        pager.querySelector('[data-mc-page]').textContent = `Page ${page + 1} of ${pages}`;
        pager.querySelector('[data-mc-prev]').disabled = page === 0;
        pager.querySelector('[data-mc-next]').disabled = page >= pages - 1;
      }
    };
    const turn = (d) => { page += d; apply(); rack.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' }); };
    pager?.querySelector('[data-mc-prev]').addEventListener('click', () => turn(-1));
    pager?.querySelector('[data-mc-next]').addEventListener('click', () => turn(1));
    pagingBtn?.addEventListener('click', () => {
      paging = !paging;
      page = 0;
      pagingBtn.textContent = paging ? 'Show all on one page' : `Show ${per} per page`;
      apply();
    });
    filters.forEach((btn) => {
      btn.addEventListener('click', () => {
        filters.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.mcFilter === btn.dataset.mcFilter)));
        page = 0;
        apply(btn.dataset.mcFilter);
        /* Keep the pick in the address so Back and refresh return to it */
        if (pagingBtn) {
          const f = btn.dataset.mcFilter;
          const hash = f === 'all' ? '' : f.startsWith('pub:') ? `#pub=${encodeURIComponent(f.slice(4))}` : `#grade=${f}`;
          history.replaceState(null, '', `${location.pathname}${location.search}${hash}`);
        }
      });
    });
    sort?.addEventListener('change', () => {
      const by = sort.value;
      const sorted = [...cards].sort((a, b) => {
        if (by === 'price-asc') return a.dataset.price - b.dataset.price;
        if (by === 'price-desc') return b.dataset.price - a.dataset.price;
        return a.dataset.index - b.dataset.index;
      });
      sorted.forEach((c) => grid.appendChild(c));
      apply();
    });
    apply('all');
    /* Arriving from "View all" with a grade picked: #grade=9.8 */
    /* Only a real number counts as a grade; anything else (abc, 9.8.8) falls back to All */
    const want = (location.hash.match(/grade=(\d+(?:\.\d+)?)(?![\d.])/) || [])[1];
    if (want) {
      const btn = filters.find((b) => Number(b.dataset.mcFilter) === Number(want) && !b.dataset.href);
      if (btn) btn.click();
      else {
        /* No item at that grade here: say so instead of quietly showing everything */
        filters.forEach((b) => b.setAttribute('aria-pressed', 'false'));
        apply(want);
      }
    }
    /* ... or a publisher: #pub=Image */
    const pub = (location.hash.match(/pub=([^&]+)/) || [])[1];
    if (pub) {
      let name = '';
      try { name = decodeURIComponent(pub); } catch (e) { /* broken link: show everything */ }
      if (name) filters.find((b) => b.dataset.mcFilter === `pub:${name}`)?.click();
    }

    const dialog = rack.querySelector('[data-mc-dialog]');
    const body = rack.querySelector('[data-mc-dialog-body]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    let opener = null;
    /* Delegated, so tiles swapped in by Shopify's filters still open */
    rack.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-mc-quickview]');
      const card = btn?.closest('[data-mc-card]');
      const tpl = card?.querySelector('template[data-mc-lighttable]');
      if (!tpl) return;
      e.preventDefault();
      opener = btn;
      body.replaceChildren(tpl.content.cloneNode(true));
      bindFlip(body);
      dialog.showModal();
    });
    rack.querySelector('[data-mc-dialog-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => { body.replaceChildren(); opener?.focus(); });
  }

  /* Cert check: CGC's public verification until the hub endpoint exists */
  function initCert(form) {
    const msg = form.querySelector('[data-mc-cert-msg]');
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const cert = (form.cert.value || '').replace(/\D/g, '');
      if (cert.length < 7 || cert.length > 12) {
        msg.textContent = 'That doesn’t look like a CGC cert number. It’s the 7 to 12 digit number on the label.';
        form.cert.focus();
        return;
      }
      msg.textContent = `Opening CGC’s record for ${cert}.`;
      window.open(`https://www.cgccomics.com/certlookup/${cert}/`, '_blank', 'noopener');
    });
  }

  /* Product page: every in-stock copy of this book (listings with the same title) */
  async function initCopies(box) {
    const title = box.dataset.title;
    const key = box.dataset.key || '';
    /* Search by the book's words (no "CGC", grade or "variant") so differently worded listings turn up */
    const words = key.split('~')[0] || title;
    const root = window.Shopify?.routes?.root || '/';
    try {
      const res = await fetch(`${root}search?q=${encodeURIComponent(words)}&type=product&view=mc-copies`);
      if (!res.ok) return;
      const all = await res.json();
      const same = all.filter((p) => p.available && (key ? p.key === key : p.title.trim().toLowerCase() === title.trim().toLowerCase()));
      if (same.length < 2) return;
      const list = box.querySelector('[data-mc-copies-list]');
      same.forEach((p, i) => {
        const li = document.createElement('li');
        li.className = 'mc-copies__row';
        const here = p.handle === box.dataset.handle;
        /* Grade and the full cert number tell the copies apart (Jemiah, 2026-10-29) */
        const parts = [p.grade ? `Grade ${p.grade}` : '', p.cert ? `Cert ${p.cert}` : ''].filter(Boolean);
        const certTxt = parts.length ? parts.join(' · ') : `Copy ${i + 1}`;
        li.innerHTML = `${p.image ? `<img src="${p.image}" alt="" width="48" loading="lazy">` : '<span></span>'}
          <div class="mc-copies__meta"><a href="${p.url}"></a><span class="mc-mono"></span></div>
          <form class="mc-add" data-mc-add action="${root}cart/add" method="post">
            <input type="hidden" name="id" value="${p.variant}"><input type="hidden" name="quantity" value="1">
            <button type="submit" class="mc-btn mc-btn--small">Add</button></form>`;
        li.querySelector('a').textContent = here ? `${certTxt} (this one)` : certTxt;
        li.querySelector('.mc-mono').textContent = p.price;
        list.appendChild(li);
      });
      box.hidden = false;
      bindAdd(box);
    } catch (err) { /* the list is a bonus; leave it hidden */ }
  }

  /* Homepage cover: show one item from the pool at random on each visit */
  function initCoverRotate(cover) {
    const stages = [...cover.querySelectorAll('.mc-cover__stage[data-mc-cover-item]')];
    if (stages.length < 2) return;
    const pick = String(Math.floor(Math.random() * stages.length));
    cover.querySelectorAll('[data-mc-cover-item]').forEach((el) => { el.hidden = el.dataset.mcCoverItem !== pick; });
  }

  /* Light / Dark / Auto: remember the choice on this device (the <head> script applies it early) */
  function initModeSwitch(box) {
    const root = document.documentElement;
    const mark = () => box.querySelectorAll('[data-mc-mode-set]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.mcModeSet === (root.dataset.mcMode || 'light'))));
    box.querySelectorAll('[data-mc-mode-set]').forEach((b) => b.addEventListener('click', () => {
      root.dataset.mcMode = b.dataset.mcModeSet;
      try { localStorage.setItem('mc-mode', b.dataset.mcModeSet); } catch (e) { /* private window: applies to this page only */ }
      document.querySelectorAll('[data-mc-mode-switch]').forEach((s) => s.dispatchEvent(new Event('mc:mode')));
    }));
    box.addEventListener('mc:mode', mark);
    mark();
  }

  /* Desktop mega menu also opens on hover, like the old theme; click, Enter and Esc still work (QC 2026-11-01) */
  function initMegaHover() {
    if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
    document.querySelectorAll('.header__inline-menu details.mega-menu').forEach((d) => {
      if (d.dataset.mcHover) return;
      d.dataset.mcHover = '1';
      const summary = d.querySelector('summary');
      let timer;
      let hoverOpenedAt = 0;
      /* A click right after hover opened the menu would close it again; keep it open instead (QC 2026-11-01). A second click still closes. */
      summary?.addEventListener('click', (e) => {
        if (d.open && hoverOpenedAt) {
          e.preventDefault();
          e.stopImmediatePropagation();
          hoverOpenedAt = 0;
        }
      }, true);
      const set = (open) => {
        if (d.open === open) return;
        d.open = open;
        summary?.setAttribute('aria-expanded', String(open));
      };
      d.addEventListener('mouseenter', () => {
        clearTimeout(timer);
        document.querySelectorAll('.header__inline-menu details.mega-menu[open]').forEach((o) => {
          if (o !== d) { o.open = false; o.querySelector('summary')?.setAttribute('aria-expanded', 'false'); }
        });
        if (!d.open) hoverOpenedAt = Date.now();
        set(true);
      });
      d.addEventListener('mouseleave', () => { clearTimeout(timer); hoverOpenedAt = 0; timer = setTimeout(() => set(false), 180); });
    });
    /* Esc closes a menu opened by hover too, without moving the mouse (WCAG 1.4.13; QC 2026-11-01) */
    if (!document.documentElement.dataset.mcMenuEsc) {
      document.documentElement.dataset.mcMenuEsc = '1';
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        document.querySelectorAll('.header__inline-menu details.mega-menu[open]').forEach((o) => {
          o.open = false;
          o.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        });
      });
    }
  }

  /* Make an offer (0.18.0): stop offers under the floor before they're sent, without
     saying the floor out loud, and reopen the panel after the form posts. */
  function initOffer(form) {
    if (form.dataset.mcOfferReady) return;
    form.dataset.mcOfferReady = '1';
    const input = form.querySelector('[data-mc-offer-floor]');
    if (form.querySelector('.mc-form__ok, .mc-form__err')) {
      const d = form.closest('details');
      if (d) d.open = true;
    }
    if (!input) return;
    const floor = parseFloat(input.dataset.mcOfferFloor) || 0;
    const price = parseFloat(input.dataset.mcOfferPrice) || Infinity;
    const check = () => {
      const v = parseFloat(input.value);
      let msg = '';
      if (input.value.trim() === '' || Number.isNaN(v)) msg = 'Enter your offer in dollars.';
      else if (v < floor) msg = "That's below what we can accept for this one. Try a higher offer.";
      else if (v > price) msg = "That's more than the price. Just add it to your cart.";
      input.setCustomValidity(msg);
    };
    input.addEventListener('input', check);
    form.addEventListener('submit', (e) => {
      check();
      if (!form.checkValidity()) { e.preventDefault(); form.reportValidity(); return; }
      const btn = form.querySelector('button[type="submit"]');
      if (btn) { if (btn.disabled) { e.preventDefault(); return; } btn.disabled = true; btn.textContent = 'Sending…'; }
    });
  }

  function init(scope = document) {
    initMegaHover();
    scope.querySelectorAll('[data-mc-ticker]').forEach(initTicker);
    scope.querySelectorAll('[data-mc-cover-rotate]').forEach(initCoverRotate);
    scope.querySelectorAll('.mc-cover__stage').forEach((s) => { bindFlip(s); initTilt(s); });
    scope.querySelectorAll('[data-mc-inspect]').forEach(initInspect);
    scope.querySelectorAll('[data-mc-rack]').forEach(initRack);
    scope.querySelectorAll('.mc-rack, .mc-cover, [data-mc-rack]').forEach(bindAdd);
    scope.querySelectorAll('[data-mc-cert]').forEach(initCert);
    scope.querySelectorAll('[data-mc-copies]').forEach(initCopies);
    scope.querySelectorAll('[data-mc-mode-switch]').forEach(initModeSwitch);
    scope.querySelectorAll('.mc-offer__form').forEach(initOffer);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  /* Re-run inside the theme editor when a section is added or changed */
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
